export enum GlobalSearchItemType {
  Plant = 'Plant',
  Area = 'Area',
  ProductionLine = 'ProductionLine',
  Department = 'Department',
  Equipment = 'Equipment'
}

export enum GlobalSearchProperty {
  PlantUpmId = 'plantUpmId',
  PlantPlantId = 'plantPlantId',
  PlantSiteId = 'plantSiteId',
  PlantName = 'plantName',
  PlantCountry = 'plantCountry',
  PlantManagementId = 'plantManagementId',
  PlantCurrency = 'plantCurrency',
  PlantStatusCode = 'plantStatusCode',
  PlantStatusName = 'plantStatusName',

  AreaUpmId = 'areaUpmId',
  AreaTypeCode = 'areaTypeCode',
  AreaTypeName = 'areaTypeName',
  AreaTypeOrderGroup = 'areaTypeOrderGroup',

  ProductionLineUpmId = 'productionLineUpmId',
  ProductionLineCode = 'productionLineCode',

  DepartmentUpmId = 'departmentUpmId',
  DepartmentDisplayValue = 'departmentDisplayValue',
  DepartmentDisplayValueEnglish = 'departmentDisplayValueEnglish',
  DepartmentSourceSystemCode = 'departmentSourceSystemCode',
  DepartmentIsDeletedInSource = 'departmentIsDeletedInSource',
  DepartmentTypeCode = 'departmentTypeCode',
  DepartmentTypeName = 'departmentTypeName',
  DepartmentTypeKey = 'departmentTypeKey',

  EquipmentUpmId = 'equipmentUpmId',
  EquipmentText = 'equipmentText',
  EquipmentSource = 'equipmentSource',
  EquipmentSourceId = 'equipmentSourceId',
  EquipmentFunctionalLocation = 'equipmentFunctionalLocation',
  EquipmentIsDeletedInSource = 'equipmentIsDeletedInSource',
  EquipmentTypeCode = 'equipmentTypeCode',
  EquipmentTypeName = 'equipmentTypeName',
  EquipmentTypeKey = 'equipmentTypeKey'
}

export enum FilterOperation {
  Contains = 'contains',
  StartsWith = 'startsWith',
  EndsWith = 'endsWith',
  In = 'in',
  NotIn = 'notIn',
  Equal = 'equal',
  NotEqual = 'notEqual'
}

export enum OrderDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum EquipmentSourceSystem {
  ExcelTemplate = 'ExcelTemplate',
  API = 'API',
  PR0010 = 'PR0010',
  PRA010 = 'PRA010',
  PRS010 = 'PRS010'
}

export interface GlobalSearchFilterItem {
  property: GlobalSearchProperty
  operation: FilterOperation
  values: string[]
}

export interface GlobalSearchOrderItem {
  property: GlobalSearchProperty
  direction: OrderDirection
}

export interface GlobalSearchParameters {
  pageNumber: number
  pageSize: number
  filters: GlobalSearchFilterItem[]
  orderBy?: GlobalSearchOrderItem[]
  itemTypes: GlobalSearchItemType[]
}

export interface TypeDto {
  name: string
  code: string
}

export interface TypeDepartmentDto extends TypeDto {
  key: string
}

export interface TypeEquipmentDto extends TypeDto {
  key: string
}

export interface PlantSearchItemDto {
  upmId: string
  itemType: GlobalSearchItemType.Plant
  plantId: string
  siteId: string | null
  name: string
  country: string
  managementId: string
  currency: string | null
  statusCode: string
  statusName: string
}

export interface AreaSearchItemDto {
  upmId: string
  itemType: GlobalSearchItemType.Area
  type: TypeDto
  orderGroup: number
  plantUpmId: string
  plantCode: string
}

export interface ProductionLineSearchItemDto {
  upmId: string
  itemType: GlobalSearchItemType.ProductionLine
  productionLineCode: string
  plantUpmId: string
  plantCode: string
  areaUpmId: string
}

export interface DepartmentSearchItemDto {
  upmId: string
  itemType: GlobalSearchItemType.Department
  type: TypeDepartmentDto
  displayValue?: string
  displayValueEnglish?: string
  sourceSystemCode?: string
  isDeletedInSource?: boolean
  plantUpmId: string
  plantCode: string
  areaUpmId: string
  productionLineUpmId: string
}

export interface EquipmentSearchItemDto {
  upmId: string
  itemType: GlobalSearchItemType.Equipment
  type: TypeEquipmentDto
  text: string
  source?: EquipmentSourceSystem
  sourceId?: string
  functionalLocation?: string
  isDeletedInSource?: boolean
  plantUpmId: string
  plantCode: string
  areaUpmId: string
  productionLineUpmId: string
  departmentUpmId: string
}

export type GlobalSearchResultItem =
  | PlantSearchItemDto
  | AreaSearchItemDto
  | ProductionLineSearchItemDto
  | DepartmentSearchItemDto
  | EquipmentSearchItemDto

export interface PaginationHeader {
  currentPage: number
  pageSize: number
  totalItems: number
  totalPages: number
  hasNext: boolean
  hasPrevious: boolean
}

export interface GlobalSearchResponse {
  items: GlobalSearchResultItem[]
  pagination: PaginationHeader
}
